module.exports = __webpack_public_path__ + "img/d027cbc9a1b30d0004a765d5c853e9de.png";